<template>
    <div class="row form-group">
        <div class="error" v-if="errors">
            {{ errorMessage }}
        </div>
        <label>From Airport*</label>
        <autocomplete v-model="selectionFrom"> </autocomplete>
        <label>To Airport*</label>
        <autocomplete v-model="selectionTo"> </autocomplete>
        <label>Date*</label>
        <date-picker v-model="selectedDate" mode="date" >
            <template v-slot="{ inputValue, inputEvents }">
                <input :value="inputValue" v-on="inputEvents" />
            </template>
        </date-picker>
        <div class="row form-group">
            <button class="button" @click="submitForm">Submit</button>
        </div>
        <div class="row form-group" v-if="results">
            <table>
                <tr>
                    <th>Scheduled Departure</th>
                    <th>Scheduled Arrival</th>
                    <th>Actual Departure</th>
                    <th>Actual Arrival</th>
                    <th>Carrier</th>
                    <th>Flight Number</th>
                    <th>Tail Number</th>
                    <th>Date</th>
                </tr>
                <tr v-for="(flight, index) in results" v-bind:key="index" :class="getClass(index)">
                    <td>{{ flight.skeddep }}</td>
                    <td>{{ flight.skedarr }}</td>
                    <td>{{ flight.actdep }}</td>
                    <td>{{ flight.actarr }}</td>
                    <td>{{ flight.flCarrier }}</td>
                    <td>{{ flight.flnum }}</td>
                    <td>{{ flight.tail_num }}</td>
                    <td>{{ flight.fldate }}</td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import Autocomplete from "./Autocomplete"
import { DatePicker } from 'v-calendar'
import axios from "axios"

export default {
  name: 'WideSearch',
  components: {
      Autocomplete,
      DatePicker
  },
  data() {
      return {
            selectionTo: "",
            selectionFrom: "",
            selectedDate: new Date(),
            errors: false,
            errorMessage: "",
            results: null,
      }
  },
  methods: {
      submitForm() {
          this.errors = false;
          console.log('Submitting Form')
          if (this.selectionTo.length < 3 || this.selectionFrom.length < 3) {
              this.errors = true
              this.errorMessage('You must enter a valid from and to airport.')
          } else {
              console.log('flo: ' + this.selectionFrom.toLowerCase())
              console.log('fld: ' + this.selectionTo.toLowerCase())
              console.log('fldate: ')
              console.log(this.selectedDate.toISOString().substr(0,10))
              axios.get('https://gc.wandrhost.com/btsapi.php?flo=' 
                + this.selectionFrom.toLowerCase() + '&fld=' 
                + this.selectionTo.toLowerCase() + "&fldate=" 
                + this.selectedDate.toISOString().substr(0,10)).then((r) => {
                    this.results = r.data
                    console.log(r.data)
                    if (r.data === undefined ||  !this.results || this.results.length < 1) {
                        this.errors = true
                        this.errorMessage('No results.')
                    }
                }).catch((error) => {
                    console.log(error.response)
                    this.errors = true
                    this.errorMessage('No results.')
                })
          }
      },
      getClass(index) {
          return "";
      }
  }
};
</script>